"use client";

import { useSearchParams } from "next/navigation";
import CommonLanding from "../../../components/common/CommonLanding";
import { ContactIntro } from "../../../components/_pages/ContactUsPageComponent";
import { SurgicalProcedure } from "../../../components/common/CommonComponents";
import { GeneralSurgeryMdDetail } from "../../../components/_pages/GeneralSurgery/GeneralSurgeryMdDetail";
import { physicianRoboticData } from "../../../data/surgicalAssistants";
const generalSurgeryPage = () => {
  const searchParams = useSearchParams();
  const name = searchParams.get("slug"); 
  console.log("name --- " , name);
 
  const surgeonData = physicianRoboticData.find((d) => d.name === name);
  console.log("Surgeon Data --- " ,surgeonData )
  const data = surgeonData["provider_General_surgery_detail"];
  const data2 = surgeonData['cardioThoracicDetailData'];
  const data3 = surgeonData['generalSurgeryDetaillinkData'];
  const data4 = surgeonData['cardioThoracicDetaillinkData2'];

  return (
    <>
      <div className="general-surgery-detail">
        <CommonLanding
          // video={data.video}
          image={data.image}
          title1={data.title1}
          title2={data.title2}
          title3={data.title3}
          mdName={data.mdName}
          // content={data.content}
        />

        <ContactIntro introImg={data2?.intoImgData} title={data2.title} slope={data2.slope} contentTop={data2.contentTop} />
        <GeneralSurgeryMdDetail id={"surgeonD"} surgeonData={surgeonData} introImg={data4.intoImgData} title={data4.title} mdname={data4.mdname} mdcontent={data4.mdcontent} />
        <ContactIntro link={data3.link} introImg={data3.introImg} title={data3.title} slope={data3.slope} contentTop={data3.contentTop} />
        <SurgicalProcedure />
      </div>
    </>
  );
};

export default generalSurgeryPage;
